import React from "react";

import HGraph from "components/Custom/HGraph";

const SolidGauge = (props: any) => {
  const { height, data } = props;

  const guageChart = data.solidGuage.data;
  console.log("guageChart", guageChart);

  const series = guageChart.map((item) => {
    return {
      name: item.name,
      data: item.data,
      dataLabels: {
        format:
          '<div style="text-align:center">' +
          '<span style="font-size:25px">{y}</span><br/>' +
          '<span style="font-size:12px;opacity:0.4">data</span>' +
          "</div>",
      },
      tooltip: {
        valueSuffix: "data",
      },
    };
  });

  return (
    <React.Fragment>
      <div className="graphs">
        <HGraph
          width={"99.5%"}
          height={height}
          type={"solidgauge"}
          series={series}
          title={" "}
          exportTitle={" "}
        />
      </div>
    </React.Fragment>
  );
};

export default SolidGauge;
